import React, { useEffect, useRef, useState } from "react";

import { withAuthentication } from "../../hoc/withAuthentication";
import { withRouter } from "react-router-dom";
import { warningAlert } from "@/utility/helpers";
// import DialogueBox from "@/custom_components/DialogueBox";
import Modal from "@/components/Modal";
import { debounce, digitInputHandler, getActiveShop, numberInputHandler } from "@/constants/utility";
import ModalFull from "@/custom_components/ModalFull";
import * as moment from "moment";
import AdminToken from "../Navigation/Toolbar/AdminToken";
import DialogueBox from "@/custom_components/DialogueBox";
import Confirmation from "@/custom_components/Confirmation";

const keys = [1, 2, 3, 4, 5, 6, 7, 8, 9, "<", 0, ">"];

const EmployeeCode = ({
  history,
  user,
  close,
  errors,
  employeeType = "employee",
  httpClient,
  updateEmployee,
  useDialogueBox = false,
  isShopSelection = false,
}) => {
  const [employeeCode, setemployeeCode] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [confirm, setconfirm] = useState(false);

  const refs = useRef([]);
  useEffect(() => {
    if (employeeCode?.length < 4 && !useDialogueBox) {
      refs.current[employeeCode.length]?.focus();
    }
  }, [employeeCode]);
  const handleKeyPress = (event) => {
    let key = event.key;
    if (
      (event.keyCode >= 48 && event.keyCode <= 57) ||
      (event.keyCode >= 96 && event.keyCode <= 105) ||
      key === "Enter"
    ) {
      if (employeeCode?.length < 4) {
        setemployeeCode((code) => {
          if (key === "Enter" || code.length == 4) {
            return code;
          } else {
            return String(code) + String(key);
          }
        });
      }
    }
    if (key === "Enter" && employeeCode?.length >= 4) {
      handleSubmit(employeeCode);
    }
    if (key === "Backspace" && employeeCode?.length > 0) {
      deleteKeyHandler();
    }
  };
  useEffect(() => {
    // Add event listener when the component mounts
    document.addEventListener("keydown", handleKeyPress);

    // Clean up the event listener when the component unmounts
    return () => {
      document.removeEventListener("keydown", handleKeyPress);
    };
  }, [employeeCode]);
  const handleSubmit = (employeeCode) => {
    if (employeeCode?.length !== 4) return;
    setSubmitting((r) => true);

    const baseUrl = /^(admin)$/i.test(employeeType) ? "/account/admin-code/" : "/account/employee-code/";
    const message = /^(admin)$/i.test(employeeType) ? "Invalid Admin code provided." : "Employee does not exist";

    return httpClient
      .post(baseUrl + user.selectedShop, { employeeCode })
      .then((res) => {
        updateEmployee(res);
        setSubmitting((r) => false);
        setemployeeCode("");
      })
      .catch((err) => {
        warningAlert({ message });
        setSubmitting((r) => false);
        setemployeeCode("");
        // throw err;
      });
  };

  const numberKeysHandler = debounce((key) => {
    if (submitting) return;

    if (key == "<") return deleteKeyHandler();

    if (key == ">") return handleSubmit(employeeCode);

    if (employeeCode?.length < 4) {
      setemployeeCode((code) => String(code) + String(key));
    }
  }, 100);

  const keyPressHandler = (evt) => {
    if (/Backspace|Delete/i.test(evt.key)) {
      setemployeeCode((code) => code.slice(0, -1));
      return true;
    }

    if (/enter/i.test(evt.key)) {
      handleSubmit(employeeCode);
      return false;
    }

    if (!/[0-9]/.test(evt.key)) {
      evt.preventDefault();
    }
  };

  const inputHandler = (evt) => {
    const input = numberInputHandler(evt);
    setemployeeCode((code) => String(code) + String(input));
  };

  const deleteKeyHandler = () => {
    if (employeeCode?.length > 0) {
      setemployeeCode((code) => {
        const pin = String(code);
        return pin.substring(0, pin.length - 1);
      });
    }
  };

  const currentShop = getActiveShop(user);

  const handleReset = async() => {
    try {
    await httpClient.post("/account/forgotpin", {
      email: user.email,
      repairshopID: currentShop._id
    })
    .then((res) => {
      warningAlert({
        message:
          res.message,
        status: "success",
      });
    })
    // window.location.reload();
    } catch (err) {
      if (err.response && err.response.data && err.response.data.message) {
        warningAlert({ api: err.response.data.message }); 
      } else {
        warningAlert({ api: 'An unexpected error occurred.' }); 
      }
    }
  };

  const message = /admin/i.test(employeeType) ? "Type in the Admin Key." : "Type Employee code";
  const render = (
    <>  
      <div className="uk-padding-small uk-margin-auto uk-margin-large-top exclude-polling" id="EmployeeCodePopup">
        {/* <div>{currentShop.name}</div> */}
        <span className="uk-text-large uk-text-bold">Employee Access</span>
        <div className="uk-margin-small-top uk-text-small uk-text-muted">
          Please enter your employee pin
          {/* {message} to login to your account */}
        </div>
        <div className="uk-margin">
          <form>
            <div
              className=" uk-margin-bottom uk-grid uk-text-center uk-flex-center uk-width-medium uk-margin-auto uk-child-width-1-4 uk-grid-small"
              uk-grid="1"
            >
              {[1, 2, 3, 4].map((val, idx) => (
                <div key={"employeecode" + val}>
                  <div className="uk-flex uk-flex-center">
                    <div className={employeeCode?.length >= idx + 1 ? "pin_active" : `pin_default`} />
                  </div>
                </div>
              ))}
            </div>
          </form>
        </div>

        <div className=" uk-child-width-1-3 uk-width-medium uk-margin-auto uk-grid-small" uk-grid="1">
          {keys.map((key) => {
            return (
              <div key={"employee-code-" + key}>
                <div
                  onClick={() => numberKeysHandler(key)}
                  className={[
                    "tm-text-black uk-text-bold uk-button opaq font-large uk-button-large",
                    // employeeCode?.length>0 && employeeCode?.slice(-1)==key?'uk-background-danger tm-text-white':"",
                    key === "<"
                      ? ""
                      : key === ">" && employeeCode.length < 4
                      ? "disable_key"
                      : key === ">" && employeeCode.length === 4
                      ? "active_key"
                      : "default_pin_btn",
                  ].join(" ")}
                >
                  {submitting && key == ">" ? (
                    <i className="fa fa-spinner fa-spin fa-fw"></i>
                  ) : key == ">" ? (
                    "Enter"
                  ) : key === "<" && employeeCode?.length === 0 ? (
                    ""
                  ) : key === "<" ? (
                    <span className="uk-text-large">{key}</span>
                  ) : (
                    key
                  )}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </>
  );

  if (useDialogueBox)
    return (
      <DialogueBox
        message={message}
        handleSubmit={handleSubmit}
        inputHandler={(evt) => digitInputHandler(evt, 4)}
        buttonText="Login"
        hideText={true}
        close={close}
      />
    );

  return (
    <>
      {/admin/i.test(employeeType) ? (
        <Modal className="uk-background-muted uk-width-auto">
          <div className="uk-flex uk-flex-between uk-margin-small">
            {isShopSelection ? (
              <a 
                className="uk-form-label uk-text-left uk-text-bold uk-margin-small-left" 
                htmlFor="cost"
                href="#"
                onClick={(e) => {
                  e.preventDefault();
                  handleReset();
                }}
              >
                Reset Admin Pin
             </a>
            ) : <div className="uk-flex-1" /> }
            <button 
              className="uk-button uk-button-text uk-text-danger uk-text-bolder"
              onClick={close}
            >
              Close
            </button>
          </div>
          {render}
        </Modal>
      ) : (
        <ModalFull hideCloseBtn={true}>
          <div className="uk-padding-remove-horizontal">
            <header className="uk-flex uk-flex-between uk-flex-middle uk-clearfix uk-card-header uk-text-center uk-background-danger tm-text-white uk-width-1-1 uk-margin-bottom">
              <div className="uk-text-left">
                <div className="uk-flex uk-flex-between uk-flex-middle">
                  {/* <div className="pointer">
                    <span uk-icon='icon:chevron-left;ratio:1.5' />
                  </div>
                  <div className="uk-margin-left pointer">
                    <img className="uk-svg" src="/icons/header/employee.svg" />
                  </div> */}
                </div>
              </div>
              <div className="uk-text-center">
                <img style={{ height: "50px" }} src={`/icons/header/logo-${user.isRetail ? "retail" : "repair"}.svg`} />
                {/* <img className="uk-svg" src="/icons/header/logo.svg" /> */}
              </div>
              <div className="uk-text-right">
                <div className="uk-flex uk-flex-between uk-flex-middle">
                  <div className="pointer">
                    <a onClick={() => setconfirm(true)}>
                      <img className="uk-svg" src="/icons/header/logout.svg" />
                    </a>
                  </div>
                  <div onClick={() => setShowModal(true)} className="uk-margin-left pointer">
                    <img className="uk-svg" src="/icons/header/store.svg" />
                  </div>
                  {/* <div className="uk-margin-left pointer">
                    <img className="uk-svg" src="/icons/header/message.svg" />
                  </div> */}
                </div>
              </div>
            </header>
            <div className="uk-width-large uk-margin-auto">{render}</div>
          </div>
        </ModalFull>
      )}
      <style jsx>{`
        .p-5 {
          font-size: 1.7em;
        }

        .opaq {
          opacity: 0.5;
        }

        .font-large {
          font-size: 3rem;
        }
      `}</style>

      {showModal && <AdminToken close={() => setShowModal(false)} />}
      {confirm && (
        <Confirmation
          message={"Are you sure you would like to logout?"}
          proceedLabel={"Logout"}
          onCancel={() => setconfirm(false)}
          onProceed={() => {
            history.push("/logout");
          }}
        />
      )}
    </>
  );
};

export default withAuthentication(withRouter(EmployeeCode));
